import { IUser } from '~/src/dash/api/console-api';
import { addDomainAndTokenToUrl, defaultRestGetArgs, restGet } from '~/src/dash/api/rest';

export async function getUserByID(userID: number): Promise<IUser> {
  const reqUrl = addDomainAndTokenToUrl(`/user/${userID}`);
  try {
    const response = await restGet<IUser>(reqUrl, defaultRestGetArgs);
    return response.parsedBody;
  } catch (err) {
    throw err;
  }
}
